import { Outlet, Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, FileText, Users, Image, Settings, LogOut, Menu, X } from 'lucide-react'
import { useState } from 'react'

export function CmsLayout() {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const navItems = [
    { path: '/cms', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/cms/pages', icon: FileText, label: 'Pages' },
    { path: '/cms/doctors', icon: Users, label: 'Doctors' },
    { path: '/cms/media', icon: Image, label: 'Media' },
    { path: '/cms/settings', icon: Settings, label: 'Settings' },
  ]

  return (
    <div className="flex h-screen bg-background">
      <aside className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} fixed inset-y-0 left-0 z-50 w-64 bg-surface border-r border-border transition-transform lg:translate-x-0 lg:static`}>
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h1 className="text-xl font-bold text-primary">CMS</h1>
          <button onClick={() => setSidebarOpen(false)} className="lg:hidden"><X size={20} /></button>
        </div>
        <nav className="p-4 space-y-1">
          {navItems.map((item) => (
            <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${location.pathname === item.path ? 'bg-primary/10 text-primary' : 'text-text-muted hover:bg-background hover:text-text'}`}>
              <item.icon size={18} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-border">
          <Link to="/" className="flex items-center gap-3 px-3 py-2 w-full text-text-muted hover:text-text hover:bg-background rounded-lg transition-colors mb-2">
            <LogOut size={18} />
            <span>Back to Website</span>
          </Link>
        </div>
      </aside>
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="flex items-center justify-between p-4 bg-surface border-b border-border lg:hidden">
          <button onClick={() => setSidebarOpen(true)}><Menu size={20} /></button>
          <span className="font-semibold">CMS</span>
        </header>
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
